import { Component, OnInit, ViewChild } from '@angular/core';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import * as catSecciones from 'app/main/pagina/tools/gestUsu/detail/cat-secciones';
import Swal from 'sweetalert2';
/////librerias Colaboradores
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import * as colabInter from 'app/main/pagina/landingProducto/landing/admin-pulsecheck/colaboradoresLanding.interfaces';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { saveAs } from 'file-saver';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


import {MatSnackBar} from '@angular/material/snack-bar';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_secciones } from 'app/idiomas/i18n/Izzi/izzisecciones/izzisecciones.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_modales_izzi } from 'app/idiomas/i18n/Izzi/izzimodales/izzimodales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_avances } from 'app/idiomas/i18n/avances/avances.lang';
import { EnvioService } from 'app/main/wizard-cgo/services/envio.service';
// import { SurveyCheckComponent } from "../programacion/vista-gen/survey-check/survey-check.component";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { ModalErroresComponent } from "app/main/pagina/productos/certificar/tipo_2/colaboradores/modal-errores/modal-errores.component";
type AOA = any[][];

import { DATOS_API } from 'app/auth/auth.datos';

const moment = require('moment');
const momentTz = require('moment-timezone');

import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

import { NuevoColaboradorComponent } from "app/main/pagina/tools/survey-status/nuevo-colaborador/nuevo-colaborador.component";
import { ModalAgregarEncComponent } from "app/main/pagina/landingProducto/landing/admin-pulsecheck/modal-agregar-enc/modal-agregar-enc.component";
import { zonasUTC } from 'app/main/pagina/zonasUtc';

@Component({
  selector: 'adminpulsecheck',
  templateUrl: './admin-pulsecheck.component.html',
  styleUrls: ['./admin-pulsecheck.component.scss'],
  animations : fuseAnimations
})
export class AdminPulsecheckComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  columnasResultado: string[] = ['nombre','correo','acciones'];
  resultados: MatTableDataSource<any>;

  idEmpresa : string;
  productosContratadosInter : backInter.infoProductos;
  aniosPulsecheck:any[]=[];
  noce:any[]=[];
  anioseleccionado:any;
  idiomaActual:string;
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE'
  ];

  mensajesTraducirTS = {
    error1: '',
    error2: ''
  };
btnPortalConteos:boolean= false;
urlPulseNavigation:any;
pulse3Navigation:boolean;
instituto: string;

productoFocus:boolean;

///////Variables de carga de colaboradores/////////
urlAssets = DATOS_API.urlAssets;

cargando = true;
cargandoBD = false;
guardandoBD = false;
stored = false;
irProducto = false;
colabsEnBD = 0;
fechaCarga:string;
nombreEmpresa: string;
charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';

charIdiomas = this.charChinos + this.charTurcos;

regexAlfabetico = new RegExp("^[" + this.charIdiomas + "a-zA-Z  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
regexAlfanumerico = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
regexNumerico = new RegExp("^[0-9]+$");
regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

data: AOA = [];
files: any = [];

totRows = 0;

filaInicial: number;

arregloColaboradores: colabInter.Colaborador[] = [];
errores:colabInter.errorEncontrado[] = [];
erroresTotales = 0;

nombresColumnas: string[] = [];
clavesColumnas: string[] = [];
nombresColumnasBD = {} as colabInter.Colaborador;

columnasObligatorias: any[] = colabInter.COLUMNAS_OBLIGATORIAS;

// Datos certificar vigente
productoCertificar: backInter.prodCert;

//id idioma nativo
idLangNativo: string;
// tipos demograficos guardados
// tiposDemograficos: backInter.allDemograficos;
tiposDemograficos: any[] = [];

//opciones demograficas
opcionesDemograficas: any[] = [];

claveAge = 'Age';
claveGender = 'Gender';
claveTOW = 'Type of work';
claveWC = 'Work condition';
claveAntiq = 'Antiquity';
actualizadoUsuario=false;

//claves random surveykeyhk
skhk: any[] = [];

//boolean ceo encontrado
ceoEncontrado = false;

//boolean paso completo
pasoCompleto = false;

//libreria moment
moment = require('moment');

//version nueva excel
versionNueva: boolean;

datosSurveyCheck:any;
token:any;

userData:any;
validationUser:boolean=false;
validationSurvey:boolean=false;
desbloqueoEstatus:boolean=false;


//zonas horarias
zonasUTC = zonasUTC;
idiomaUtc: string;
instUtc: number;
indiceZona: number;
diferenciaUtc: number;
offsetPipe: string;
historyUpdateColaboration:any[]= [];
typeTitle=0;

  tabSeleccionada: number;
  versionesActualExcel: any;
  seccEspHabilitadas: boolean;
  seccionesEspeciales: any;

  constructor(
    private odsService: ODSService,
    private activatedRoute:ActivatedRoute,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private encuestaService: EncuestaService,
    private colaboradoresService: ColaboradoresService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private programacionService:ProgramacionService,
    private envioService: EnvioService,
  ) {
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });


    ////Idiomas colaboradores///
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_avances.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.obtieneInstituto();
  }

  ngOnInit() {
    console.log(localStorage.getItem('fechaProducto'));
    console.log(localStorage.getItem('tipoProducto'));
    this.getProductsByCompany();
    this.traduceTextosTS();
    this.obtieneInstituto();
    this.getColaboradoresFast();
    switch (localStorage.getItem('tipoProducto')) {
      case 'f1':
        this.openDialog();
        break;
    }
    this.getVersionExcel();
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        //console.log(k);
        this.mensajesTraducirTS[k] = res;
        // console.log(this.mensajesTraducirTS[k]);
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;


  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
    }
  }




private getProductsByCompany() {

    this.wizardService.getProductos().subscribe((respuesta:backInter.infoProductos) => {
      console.log("Dude");
      console.log(respuesta);
      this.productosContratadosInter = respuesta;
      this.anioseleccionado= localStorage.getItem('fechaProducto');
      console.log(this.anioseleccionado);

      if(this.productosContratadosInter){
        switch (localStorage.getItem('tipoProducto')) {
          case '3':
          this.pulseCheckAños();
          this.urlPulseNavigation='pulse/wizard';
          this.pulse3Navigation=false;
          this.productoFocus=false;
          this.typeTitle=1;
            break;
          case 'p1':
          this.pulseCheckAños3();
          this.pulse3Navigation=true;
          this.urlPulseNavigation='pulse_t1/wizard';
          this.productoFocus=false;
          this.typeTitle=1;
            break;
          case 'f1':
          this.focusAreaAños3();
          this.pulse3Navigation=true;
          this.urlPulseNavigation='focus_t1/wizard';
          this.productoFocus=true;
          this.typeTitle=2;

            break;
          default:
            break;
        }

      }
    }, error => {
      console.log("error", error);
    })
  }

  private navigateTo(ruta,productoID){
    localStorage.setItem('productoID', productoID);
    ////Variables para los requerimientos tecnicos/////
    localStorage.setItem('productoIDRequerimientos', productoID);
      this.router.navigate([ruta]);
  }
  private navigateFocus3(ruta,productoID,modifUrlShort,closeNotice,selectNotice1,selectNotice2){
    localStorage.setItem('productoID', productoID);
    ////Variables para los requerimientos tecnicos/////
    localStorage.setItem('productoIDRequerimientos', productoID);
    localStorage.setItem('fechaProducto', localStorage.getItem('fechaProducto'));
    localStorage.setItem('tipoProductoRequerimientos', localStorage.getItem('tipoProducto'));
    localStorage.setItem('productoIDRequerimientos', productoID);

    localStorage.setItem('instituto', this.instituto);
    ////Variables para los requerimientos tecnicos/////
    localStorage.setItem('fechaProductoRequerimientos', localStorage.getItem('fechaProducto'));
    localStorage.setItem('institutoRquerimientos', this.instituto);
    localStorage.setItem('tipoProducto', localStorage.getItem('tipoProducto'));
    localStorage.setItem('modifUrlShort', modifUrlShort);
    localStorage.setItem('closeNotice', closeNotice);
    localStorage.setItem('selectNotice1', selectNotice1);
    localStorage.setItem('selectNotice2', selectNotice2);
    console.log(localStorage.getItem('modifUrlShort'));
if (this.irProducto) {
  this.router.navigate([ruta]);
}else{
  Swal.fire({
    /*title: 'Are you sure?',*/
    title: this.translateSrv.instant('LANDINFOCUS.ENCUESTAS.MODAL_NO_COLAB_EMPRE'),
    icon: 'warning',
    showCancelButton: true,
reverseButtons: true,


    confirmButtonText: this.translateSrv.instant('LANDINFOCUS.MODALES.RSPSI'),
    cancelButtonText: this.translateSrv.instant('LANDINFOCUS.MODALES.RSPNO'),
  }).then((result) => {
    if (result.value) {
    this.router.navigate([ruta]);
}
});
}
  }

  private navigatePulse3(ruta,productoID,modifUrlShort,closeNotice,selectNotice1,selectNotice2){
    console.log(productoID);

    localStorage.setItem('productoID', productoID);
    ////Variables para los requerimientos tecnicos/////
    localStorage.setItem('productoIDRequerimientos', productoID);
    localStorage.setItem('fechaProducto', localStorage.getItem('fechaProducto'));
    localStorage.setItem('tipoProductoRequerimientos', localStorage.getItem('tipoProducto'));
    localStorage.setItem('productoIDRequerimientos', productoID);

    localStorage.setItem('instituto', this.instituto);
    ////Variables para los requerimientos tecnicos/////
    localStorage.setItem('fechaProductoRequerimientos', localStorage.getItem('fechaProducto'));
    localStorage.setItem('institutoRquerimientos', this.instituto);
    localStorage.setItem('tipoProducto', localStorage.getItem('tipoProducto'));
    localStorage.setItem('modifUrlShort', modifUrlShort);
    localStorage.setItem('closeNotice', closeNotice);
    localStorage.setItem('selectNotice1', selectNotice1);
    localStorage.setItem('selectNotice2', selectNotice2);
    console.log(localStorage.getItem('modifUrlShort'));

    console.log("entro este viense dssbkjcdsi");
    this.router.navigate([ruta]);
  }
  //
  pulseCheckAños(){
    let encuestaActiva:string;
    let modifUrlShort:boolean;
    let closeNotice:boolean;
    let selectNotice1:boolean;
    let selectNotice2:boolean;
    let moment = require('moment');
    let fechaActualC = moment().format('YYYY/MM/DD');
      let fechaActual:number;
      let fechaPulse:any[]=[];
      this.productosContratadosInter.productosPulseCheck.sort( (a,b) => {
        if(a.fechaPulseCheck > b.fechaPulseCheck){
          return 1;
        } else{
          return -1;
        }
      });
      console.log(this.productosContratadosInter.productosPulseCheck);

      this.productosContratadosInter.productosPulseCheck.forEach((element,i) => {
        console.log('element',element);

        let datosPulsechek:any={};
        console.log(element.completoPulseCheck);

        // let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
        let fechaPortal= moment(element.fechaLanzamiento).isBefore(moment(fechaActualC));
        console.log('fechaPortal',fechaPortal);

        if(fechaPortal){
          console.log("econtro 1");
        this.btnPortalConteos=true;
      }else{
        this.btnPortalConteos=false;
      }
      console.log('this.btnPortalConteos',this.btnPortalConteos);
      // if (element.surveyProductId) {
      //   closeNotice=element.surveyProductId.config.closeNotice;
      //   selectNotice1=element.surveyProductId.config.selectNotice1;
      //   selectNotice2=element.surveyProductId.config.selectNotice2;
      //   modifUrlShort=element.surveyProductId.config.customSurveyUrl;
      // }else{
        console.log('entro producto viejo');
        modifUrlShort=true;
        closeNotice=true;
        selectNotice1=true;
        selectNotice2=true;
      // }

        if(fechaActual){
          console.log("entro fecha actul",fechaActual);

         datosPulsechek={
           completoPulseCheck: element.completoPulseCheck,
           fechaLanzamiento: element.fechaLanzamiento,
           // fechaLanzamiento: moment(element.fechaLanzamiento).utc().format(),
           fechaPulseCheck: element.fechaPulseCheck,
           idPlantilla: element.idPlantilla,
           idPulseCheck: element.idPulseCheck,
           btnPortalConteos:this.btnPortalConteos,
           idSurvey: element.idSurvey,
           tokenConfig: element.tokenConfig,
           numero:element.numero,
           // encuestaActiva:encuestaActiva,
           modifUrlShort:modifUrlShort,
           closeNotice:closeNotice,
           selectNotice1:selectNotice1,
           selectNotice2:selectNotice2,
         }

          console.log('datosPulsechek',datosPulsechek);

          if(element.fechaPulseCheck == fechaActual){
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaPulseCheck;
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
        }
        else{
          console.log("entro primero este visne ");
          datosPulsechek={
            completoPulseCheck: element.completoPulseCheck,
            fechaLanzamiento: element.fechaLanzamiento,
            fechaPulseCheck: element.fechaPulseCheck,
            idPlantilla: element.idPlantilla,
            idPulseCheck: element.idPulseCheck,
            btnPortalConteos:this.btnPortalConteos,
            idSurvey: element.idSurvey,
            tokenConfig: element.tokenConfig,
            numero:element.numero,
            // encuestaActiva:encuestaActiva,
            modifUrlShort:modifUrlShort,
            closeNotice:closeNotice,
            selectNotice1:selectNotice1,
            selectNotice2:selectNotice2,
          }

          fechaActual=element.fechaPulseCheck;
          // fechaPulse.push(element);
          fechaPulse.push(datosPulsechek);
          console.log('datosPulsechek',datosPulsechek);
        }

        fechaPulse.sort( (a,b) => {
          if(a.numero > b.numero){ return 1; } else{ return -1; }
        });

        if(this.productosContratadosInter.productosPulseCheck.length ==(i+1)){
          this.aniosPulsecheck.push({fecha: element.fechaPulseCheck, datos: fechaPulse});
        }
      });
      this.cargando=false;
      console.log(this.aniosPulsecheck);
    }

  pulseCheckAños3(){
    let encuestaActiva:string;
    let modifUrlShort:boolean;
    let closeNotice:boolean;
    let selectNotice1:boolean;
    let selectNotice2:boolean;
    let moment = require('moment');
    let fechaActualC = moment().format('YYYY/MM/DD');
      let fechaActual:number;
      let fechaPulse:any[]=[];
      let pulseV3:any[]=[];
this.productosContratadosInter.productosCertificar.forEach((element) => {
if (element.idProducto==42) {
pulseV3.push(element);
}
});

      pulseV3.sort( (a,b) => {
        if(a.fechaCertificar > b.fechaCertificar){
          return 1;
        } else{
          return -1;
        }
      });
      console.log(pulseV3);


      pulseV3.forEach((element,i) => {
        console.log('element',element);

        let datosPulsechek:any={};
        console.log(element.completoCertificar);

        let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
        let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
        let modifUrlShort:boolean;
        let closeNotice:boolean;
        let selectNotice1:boolean;
        let selectNotice2:boolean;
        if(fechaPortal){
          console.log("econtro 1");
        this.btnPortalConteos=true;
      }else{
        this.btnPortalConteos=false;
      }
console.log('surveyProductId');

      if (element.surveyProductId) {
        console.log('entro surveyProductId');

        closeNotice=element.surveyProductId.config.closeNotice;
        selectNotice1=element.surveyProductId.config.selectNotice1;
        selectNotice2=element.surveyProductId.config.selectNotice2;
        modifUrlShort=element.surveyProductId.config.customSurveyUrl;
      }else{
        console.log('entro producto viejo');
        modifUrlShort=true;
        closeNotice=true;
        selectNotice1=true;
        selectNotice2=true;
      }
        if(fechaActual){
         datosPulsechek={
           completoCertificar: element.completoCertificar,
           fechaLanzamiento: element.fechaLanzamiento,
           fechaCertificar: element.fechaCertificar,
           idPlantilla: element.idPlantilla,
           idCertificar: element.idCertificar,
           idSurvey: element.idSurvey,
           tokenConfig: element.tokenConfig,
           btnPortalConteos:this.btnPortalConteos,
           encuestaActiva:element.openSurvey,
           numPulse:element.numPulse,
           modifUrlShort:modifUrlShort,
           closeNotice:closeNotice,
           selectNotice1:selectNotice1,
           selectNotice2:selectNotice2,

         }

          console.log(datosPulsechek);

          if(element.fechaCertificar == fechaActual){
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaCertificar;
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
        }
        else{
          datosPulsechek={
            completoCertificar: element.completoCertificar,
            fechaLanzamiento: element.fechaLanzamiento,
            fechaCertificar: element.fechaCertificar,
            idPlantilla: element.idPlantilla,
            idCertificar: element.idCertificar,
            idSurvey: element.idSurvey,
            tokenConfig: element.tokenConfig,
            btnPortalConteos:this.btnPortalConteos,
            numPulse:element.numPulse,
            encuestaActiva:element.openSurvey,
            modifUrlShort:modifUrlShort,
            closeNotice:closeNotice,
            selectNotice1:selectNotice1,
            selectNotice2:selectNotice2,

          }
          fechaActual=element.fechaCertificar;
          // fechaPulse.push(element);
          fechaPulse.push(datosPulsechek);
        }
        fechaPulse.sort( (a,b) => {
          if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
        });
        if(pulseV3.length ==(i+1)){
          this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse});
        }
      });
      this.cargando=false;
      console.log(this.aniosPulsecheck);
    }

  focusAreaAños3(){
    this.aniosPulsecheck=[];
    let encuestaActiva:string;
    let modifUrlShort:boolean;
    let closeNotice:boolean;
    let selectNotice1:boolean;
    let selectNotice2:boolean;
    let moment = require('moment');
    let fechaActualC = moment().format('YYYY/MM/DD');
      let fechaActual:number;
      let fechaPulse:any[]=[];
      let pulseV3:any[]=[];
this.productosContratadosInter.productosCertificar.forEach((element) => {
if (element.idProducto==43) {
pulseV3.push(element);
}
});

      pulseV3.sort( (a,b) => {
        if(a.fechaCertificar > b.fechaCertificar){
          return 1;
        } else{
          return -1;
        }
      });
      console.log(pulseV3);


      pulseV3.forEach((element,i) => {
        console.log('element',element);

        let datosPulsechek:any={};
        console.log(element.completoCertificar);

        let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
        let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
        let modifUrlShort:boolean;
        let closeNotice:boolean;
        let selectNotice1:boolean;
        let selectNotice2:boolean;
        if(fechaPortal){
          console.log("econtro 1");
        this.btnPortalConteos=true;
      }else{
        this.btnPortalConteos=false;
      }
console.log('surveyProductId');

      if (element.surveyProductId) {
        console.log('entro surveyProductId');

        closeNotice=element.surveyProductId.config.closeNotice;
        selectNotice1=element.surveyProductId.config.selectNotice1;
        selectNotice2=element.surveyProductId.config.selectNotice2;
        modifUrlShort=element.surveyProductId.config.customSurveyUrl;
      }else{
        console.log('entro producto viejo');
        modifUrlShort=true;
        closeNotice=true;
        selectNotice1=true;
        selectNotice2=true;
      }
        if(fechaActual){
         datosPulsechek={
           completoCertificar: element.completoCertificar,
           fechaLanzamiento: element.fechaLanzamiento,
           fechaCertificar: element.fechaCertificar,
           idPlantilla: element.idPlantilla,
           idCertificar: element.idCertificar,
           idSurvey: element.idSurvey,
           tokenConfig: element.tokenConfig,
           btnPortalConteos:this.btnPortalConteos,
           encuestaActiva:element.openSurvey,
           numPulse:element.numPulse,
           modifUrlShort:modifUrlShort,
           closeNotice:closeNotice,
           selectNotice1:selectNotice1,
           selectNotice2:selectNotice2,
           nameSurvey:element.nameSurvey,

         }

          console.log(datosPulsechek);

          if(element.fechaCertificar == fechaActual){
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaCertificar;
            // fechaPulse.push(element);
            fechaPulse.push(datosPulsechek);
          }
        }
        else{
          datosPulsechek={
            completoCertificar: element.completoCertificar,
            fechaLanzamiento: element.fechaLanzamiento,
            fechaCertificar: element.fechaCertificar,
            idPlantilla: element.idPlantilla,
            idCertificar: element.idCertificar,
            idSurvey: element.idSurvey,
            tokenConfig: element.tokenConfig,
            btnPortalConteos:this.btnPortalConteos,
            numPulse:element.numPulse,
            encuestaActiva:element.openSurvey,
            modifUrlShort:modifUrlShort,
            closeNotice:closeNotice,
            selectNotice1:selectNotice1,
            selectNotice2:selectNotice2,
            nameSurvey:element.nameSurvey,

          }
          fechaActual=element.fechaCertificar;
          // fechaPulse.push(element);
          fechaPulse.push(datosPulsechek);
        }
        fechaPulse.sort( (a,b) => {
          if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
        });
        if(pulseV3.length ==(i+1)){
          this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse});
        }
      });
      this.cargando=false;
      console.log(this.aniosPulsecheck);
    }


    obtenerProductoId(productoID,fecha){
      console.log('productoID',productoID);

      let inicio='accesoPortalLanding'
      console.log("entro este visne ");
      localStorage.setItem('productoID', productoID);
      localStorage.setItem('tipoProducto', localStorage.getItem('tipoProducto'));
      localStorage.setItem('fechaProducto', fecha);
      localStorage.setItem('accesoPortalLanding', inicio);

  }



  nombreEncuesta(){
      let texto = 'LANDINFOCUS.MODALES.CREARENC';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      let rspAceptar = 'LANDINFOCUS.MODALES.RSPACEPTAR';
      this.translateSrv.get(rspAceptar).subscribe((res: string) => { rspAceptar = res; });

  Swal.fire({
  title: texto,
  input: 'text',
  inputAttributes: {
    autocapitalize: 'off'
  },
  showCancelButton: true,
reverseButtons: true,
  confirmButtonText: rspAceptar,
  showLoaderOnConfirm: true,

  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.value) {
  let data:any;
  data = {
    productoId: 43,
    fechaProducto: this.anioseleccionado,
    secciones : catSecciones.seccionesFocusArea3,
    nombreProducto:'focus 1',
    nameSurvey:result.value,
  };
    console.log(data);
  this.odsService.matchCompanyProduct(localStorage.getItem('companyID'),data).subscribe((respuesta:any) => {
    console.log(respuesta);
    let modal = 'LANDINFOCUS.MODALES.CORRECTO';
    this.translateSrv.get(modal).subscribe((res1: string) => { modal = res1; });

    Swal.fire({
      title: modal + result.value
    })
    this.getProductsByCompany();
  }, error => {
    console.log(error);
  });


  }
})
 }

  eliminarEncuesta(productId){
    let texto = 'LANDINFOCUS.MODALES.DELETE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let rspSi = 'LANDINFOCUS.MODALES.RSPSI';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    let rspNo = 'LANDINFOCUS.MODALES.RSPNO';
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    let rspOk = 'LANDINFOCUS.MODALES.RSPOK';
    this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });

    Swal.fire({
      /*title: 'Are you sure?',*/
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo,
    }).then((result) => {
      if (result.value) {

  this.odsService.deleteProductCompany(localStorage.getItem('companyID'),productId).subscribe((respuesta:any) => {
    console.log(respuesta);
    let modal = 'LANDINFOCUS.MODALES.COMDELETE';
    this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });

    Swal.fire({
      icon: 'success',
      title: modal,

      confirmButtonText: rspOk,
    });

    this.getProductsByCompany();
  }, error => {
    console.log(error);
  });
}
});

}

// Funciones colaboradores

getColaboradoresFast(){
  this.colaboradoresService.getColaboradoresEmpresaFoc().subscribe( (getFast: any) => {
    console.log(getFast);
    if(getFast.success == true && getFast.numeroColaboradores > 0){
      this.stored = true;
      this.irProducto=true;
      this.colabsEnBD = getFast.numeroColaboradores;
      this.fechaCarga = getFast.fecha;
      console.log("Perro");
      console.log(this.fechaCarga);
    }
    this.cargando = false;
  });
}

verListaColaboradores(bypass?:boolean){
  if(!this.resultados || bypass){
    Swal.fire({
      title: this.translateSrv.instant('LANDINFOCUS.MODALES.CARGANDOLISTA'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.colaboradoresService.getColaboradoresFullNew().subscribe( (respuesta:any) => {
      console.log("getFullNew:",respuesta);
      this.resultados = new MatTableDataSource<any>(respuesta.bdcolaboradores);
      // this.buscando = false;
      setTimeout(() => this.resultados.paginator = this.paginator);
      Swal.close();
      this.tabSeleccionada = 2;
    });
  }
  else this.tabSeleccionada = 2;
}

editarColaborador(datosColaborador:any){
  const dialogRef = this.dialog.open(NuevoColaboradorComponent, {
    width: '80%',
    height: '90%',
    disableClose: true,
    data: {
      SurveyId: 'SINDATOS',
      idEmpresa: localStorage.getItem('companyID'),
      idProducto: localStorage.getItem('companyID'),
      nombreProductoSel: 'SINDATOS',
      datosColaborador,
      modificacion: true,
      prodFocus: true
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log("result2:",result);
    // this.actualizado = result;
    if(result != undefined){
      let indiceColab = this.resultados.data.findIndex(item => item._id == result.datosObtenidos._id);
      console.log("indice:",indiceColab);

      if(indiceColab != -1){
        this.resultados.data.splice(indiceColab,1,result.datosObtenidos);
        this.resultados.data = this.resultados.data;
      }
      // console.log("resultados:",this.resultados);
    }
  });
}

agregarColaborador(){
  const dialogRef = this.dialog.open(NuevoColaboradorComponent, {
    width: '80%',
    height: '90%',
    disableClose: true,
    data: {
      SurveyId: 'SINDATOS',
      idEmpresa: localStorage.getItem('companyID'),
      idProducto: localStorage.getItem('companyID'),
      nombreProductoSel: 'SINDATOS',
      prodFocus: true
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log("result2:",result);
    if(result != undefined){
      this.verListaColaboradores(true);
    }
  });
}

buscaColaborador(filtro: string){
  this.resultados.filter = filtro.trim().toLowerCase();
}

borrarColaboradores(){
    if(this.stored && this.colabsEnBD > 0 && this.fechaCarga){
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELETE_1') + this.colabsEnBD + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELETE_2'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          confirmButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI'),
          cancelButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO')
        }).then((result) => {
          if (result.value) {
            let inicio = new Date();
            let fin: any;
            this.colaboradoresService.deleteColaboradoresEmpresaFoc()
            .subscribe( (resultado: any) => {
              console.log(resultado);

              if(resultado.success == true ){
                this.stored = false;
                this.colabsEnBD = 0;
                this.fechaCarga = null;
                this.irProducto=false;
                this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_1') + resultado.respuesta + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_2'), 1);
              }
              else{
                this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_ERR'), 3);
              }
            });
          }
        });


    }

}
mensajeSwal(mensaje:string, tipoMsg:number){
  let tipo: any;
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  switch(tipoMsg){
    case 1: tipo = 'success'; break;
    case 2: tipo = 'warning'; break;
    case 3: tipo = 'error'; break;
  }
  Swal.fire({
    title: mensaje,
    icon: tipo,
    confirmButtonText: rspSi,
    confirmButtonColor: '#e40601'
  });
}

infoError(detalleError:string){
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  Swal.fire({
    title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError),
    icon: 'warning',
    confirmButtonText: rspSi,
    confirmButtonColor: '#e40601'
  });
}

deleteAttachment(index?:number, origen?:boolean) {
  if(origen){
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELFILE'),
      icon: 'success',
      confirmButtonColor: '#e40601'
    });
  }
  this.files = [];
  this.data = [];
  this.arregloColaboradores = [];
  this.errores = [];
  this.erroresTotales = 0;
  this.nombresColumnas = [];
  this.clavesColumnas = [];
  this.stored = false;
  this.colabsEnBD = 0;
  this.fechaCarga = null;
  this.totRows = 0;
}

////LEER XLSM
onFileChange(evt: any) {
  this.versionNueva = false;
  this.cargandoBD = true;
  let fec1 = new Date();
  /* wire up file reader */
  const target: DataTransfer = <DataTransfer>(evt.target);
  if (target.files.length !== 1) throw new Error('Cannot use multiple files');

  if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      if(wb.SheetNames.includes("Referencias") || wb.SheetNames.includes("Version")){
        /* grab first sheet */
        let numeroHojaALeer = 0;
        const wsname: string = wb.SheetNames[numeroHojaALeer];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));

        // console.log("data:",this.data);
        // console.log("wb:",wb);
        // console.log("ws:",wb.Sheets);
        // console.log("wsn:",wb.SheetNames);

        if(wb.SheetNames.includes("Version")){
          this.versionNueva = true;
        }

        let conRegistros: boolean;
        let numColumnas: number;

        if(this.versionNueva){
          console.log("analisis version nueva");

          if(this.data.length > 3){ //si hay mas de tres filas (fila boton, fila instrucciones y fila nombres columnas)
            conRegistros = true;
            numColumnas = this.data[2].length;
            this.filaInicial = 3;
            console.log("numero de columnas:"+numColumnas);
            // console.log("columnas:",this.data[2]);
            this.nombresColumnas = this.data[2];

            let indiceReferencias: number;
            switch(this.instituto){
              case 'MX': indiceReferencias = wb.SheetNames.indexOf("Referencias_MX"); break;
              case 'CAyC': indiceReferencias = wb.SheetNames.indexOf("Referencias_CAYC"); break;
              case 'HK': indiceReferencias = wb.SheetNames.indexOf("Referencias_HK"); break;
              case 'TK': indiceReferencias = wb.SheetNames.indexOf("Referencias_TR"); break;
              case 'BR': indiceReferencias = wb.SheetNames.indexOf("Referencias_BR"); break;
              case 'GCTI': indiceReferencias = wb.SheetNames.indexOf("Referencias_MX"); break;
              default:  indiceReferencias = wb.SheetNames.indexOf("Referencias_WWDE");
            }

            // console.log("indiceRef:",indiceReferencias);
            if(indiceReferencias != -1){
              const hojaRef: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[indiceReferencias]];
              const datosHojaRef = <AOA>(XLSX.utils.sheet_to_json(hojaRef, {header: 1}));
              // console.log("datosHojaRef:",datosHojaRef);

              let BreakException = {};
              try {
                datosHojaRef.forEach((fila,i) => {
                  if(fila[0] != null){  //si hay informacion en la celda A continua, si no se detiene el foreach
                    if(i > 0){  //si el iterador es mayor a 0 (a partir de la segunda fila)
                      if(fila[0] == 1){   //si el status es 1 (columna habilitada)
                        this.clavesColumnas.push( hojaRef['R'+(i+1)].v.split(",")[0] );
                      }
                    }
                  }
                  else throw BreakException;
                });
              } catch (e) {
                if (e !== BreakException) throw e;
              };

              // console.log("nombresColumnas:",this.nombresColumnas);
              // console.log("clavesColumnas:",this.clavesColumnas);
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
              this.cargandoBD = false;
              console.log("trono aqui :V");
            }
          }
          else{
            this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.NOROWS'), 3); //mensaje de sin filas de colaboradores
            this.cargandoBD = false;
          }
        }
        else{
          console.log("analisis version anterior");

          if(this.data.length > 2){ //si hay mas de dos filas (la primera donde está el boton de validar y la de nombres de columnas)
            conRegistros = true;
            numColumnas = this.data[1].length;
            this.filaInicial = 2;
            console.log("numero de columnas:"+numColumnas);

            let BreakException = {};
            try {
              this.data[1].forEach((nombreCol, i) => {  //fila de nombres de columnas
                this.nombresColumnas.push(nombreCol);
                let infoCeldaNombre = wb.Sheets[wsname][colabInter.LETRAS[i]+'2'];
                if(infoCeldaNombre.c){
                  let claveColumaArr = infoCeldaNombre.c[0].t.split("|");
                  this.clavesColumnas.push(claveColumaArr[0]);
                }
                else{
                  conRegistros = false;
                  throw BreakException;
                }
              });
            } catch (e) {
                if (e !== BreakException) throw e;
            };
          }
          else{
            this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.NOROWS'), 3); //mensaje de sin filas de colaboradores
            this.cargandoBD = false;
          }
        }

        if(conRegistros){
          this.nombresColumnasExcel(numColumnas);

          let BreakException = {};
          try {
            this.data.forEach( (fila,i) => {  //ciclo que recorre las filas del archivo
              if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
                if(fila[0] != null){
                  this.validacionCelda(fila, (i+1), numColumnas);  //datos de la fila, numero real de fila, numero de columna
                }
                else{
                  throw BreakException;
                }
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };

          this.paridadBosskey();
          this.continuidadNiveles();

          //si no encontró el CEO, agrega un error de ceo no encontrado
          if(!this.ceoEncontrado){
            this.errores.push({
              numeroFila: 1,
              datos: '',
              listaErrores: [{
                numeroColumna: '',
                columna: '',
                dato: '',
                tipoError: 'noCeo'
              }]
            });
            this.erroresTotales++;
          }

          this.cargandoBD = false;
          let fec2 = new Date();
          let fx = (fec2.getTime() - fec1.getTime()) / 1000;

          console.log("registros cargados: "+this.arregloColaboradores.length);
          console.log("tiempo de carga de bd en front: "+fx+" segs");
          // console.log("valor final de barporcen: "+this.barPorcen);

          let arcs = evt.target.files
          for (let index = 0; index < arcs.length; index++) {
            const element = arcs[index];
            // console.log(element);
            this.files.push(element.name)
          }
          console.log("files de colabroadores::",this.files);

        }
        else{
          this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
          this.cargandoBD = false;
          console.log("trono aqui :V");
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
        this.cargandoBD = false;
        console.log("trono aqui :V");
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }
  else{
    this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
    this.cargandoBD = false;
    console.log("trono aqui :V");
  }
}

nombresColumnasExcel(numColumnas:number){
  // let this.nombresColumnasBD = {} as colabInter.nombresColumnasEnBD;
  this.nombresColumnasBD.productoId = ' ';
  for(let i=0;i<numColumnas;i++){
    this.nombresColumnasBD[this.clavesColumnas[i]] = this.nombresColumnas[i];
  }
  if(this.instituto == 'HK' || this.instituto == 'TK'){ //si es instituto hk o tr se agrega la columna surveykey, no viene en el excel
    this.nombresColumnasBD.surveyKey = 'Survey Key';
  }
  // console.log(this.nombresColumnasBD);
}

validacionCelda(datosFila:any, numFila:number, numColumnas:number){
  let listaErrores: colabInter.listaErrores[] = [];
  let filaCeo: boolean;
  let ownKey: string;
  let bossKey: string;

  for (let i = 0; i < numColumnas; i++) { // CICLO PARA BUSCAR EL CEO Y LA OWNKEY
    //SE IDENTIFICA AL CEO
    if(this.clavesColumnas[i] == 'ownKey'){
      ownKey = datosFila[i];
    }
    if(this.clavesColumnas[i] == 'bossKey'){
      bossKey = datosFila[i];
      if(datosFila[i] == 0){
        console.log("ceo:",datosFila);
        filaCeo = true;
        this.ceoEncontrado = true;
      }
    }
  }

  for(let i=0;i<numColumnas;i++){

    let errorFnd = false;
    let indiceCol = colabInter.CLAVES_COLUMNAS.findIndex(item => item.clave === this.clavesColumnas[i]);
    if(indiceCol != -1){

      let tipoValidacion = colabInter.CLAVES_COLUMNAS[indiceCol].validacion;
      switch(tipoValidacion){
        case 'alfabetica':
          if(datosFila[i]){
            datosFila[i].toString().trim();
          }
          if(!this.validacionAlfabetica(datosFila[i])){
            errorFnd = true;
          }
        break;
        case 'alfanumerica':
        if(!this.validacionAlfanumerica(datosFila[i])){
          errorFnd = true;
        }
        break;
        case 'numerica':
        if(!this.validacionNumerica(datosFila[i])){
          errorFnd = true;
        }
        break;
        case 'email':
        datosFila[i].trim();
        if(!this.validacionEmail(datosFila[i])){
          errorFnd = true;
          if(datosFila[i] == "*"){
            errorFnd = false;
          }
        }
        break;
      }   //evalua el contenido de la celda de acuerdo a su tipo de validacion
      if(!errorFnd){    //si no se encontró error en la celda, se hace una segunda revisión, busca vacios y evalua columnas obligatorias
        //comprueba vacio
        if(this.columnasObligatorias.indexOf(this.clavesColumnas[i]) != -1){  //si se encontro la celda en la lista de columnas obligatorias
          let vacioFnd = false;
          // if(typeof datosFila[i] == 'number'){
          if(tipoValidacion == 'numerica'){
            if(datosFila[i] == null)
            vacioFnd = true;
          } //revisa si el tipo de dato es numerico y vaclo
          else{
            if(datosFila[i] != null){
              if(datosFila[i].length == 0){
                if(filaCeo && this.clavesColumnas[i] == 'bossKey' || filaCeo && this.clavesColumnas[i] == 'bossName'){
                  vacioFnd = false;
                }
                else{
                  vacioFnd = true;
                }
              }
            }
            else{
              if(filaCeo && this.clavesColumnas[i] == 'bossKey' || filaCeo && this.clavesColumnas[i] == 'bossName'){
                vacioFnd = false;
              }
              else{
                vacioFnd = true;
              }
            }
          } //revisa si el tipo de dato es string y vacio
          if(vacioFnd){   //si encontró la celda vacia, agrega un error de celda vacia
            listaErrores.push({
              numeroColumna: colabInter.LETRAS[i],
              columna: this.nombresColumnas[i],
              dato: datosFila[i],
              tipoError: 'vacio'
            });
            this.erroresTotales++;
          }
          else{
            if(colabInter.COLUMNAS_NO_REPETIR.indexOf(this.clavesColumnas[i]) != -1){   //si la celda no estaba vacia, se busca si pertenece a una columna que prohibe repetidos
              if(this.buscaRepetidos(datosFila[i],this.clavesColumnas[i],numColumnas)){
                if(this.clavesColumnas[i] == "email" && datosFila[i] == "*"){
                  //no agregar error
                }
                else{
                  listaErrores.push({
                    numeroColumna: colabInter.LETRAS[i],
                    columna: this.nombresColumnas[i],
                    dato: datosFila[i],
                    tipoError: 'repetido'
                  });
                  this.erroresTotales++;
                }
              }
            }
            else if(this.clavesColumnas[i] == 'bossKey'){ //si un colaborador tiene como bosskey su propia clave, se guarda un error
              if(datosFila[i] == ownKey){
                listaErrores.push({
                  numeroColumna: colabInter.LETRAS[i],
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'sameKey'
                });
                this.erroresTotales++;
              }
            }
          }
        }
      }
      else{
        if(this.columnasObligatorias.indexOf(this.clavesColumnas[i]) != -1){
          listaErrores.push({
            numeroColumna: colabInter.LETRAS[i],
            columna: this.nombresColumnas[i],
            dato: datosFila[i],
            tipoError: tipoValidacion
          });
          this.erroresTotales++;
        }
      }
    }
    else{
      //crear error de columa no encontrada
      listaErrores.push({
        numeroColumna: colabInter.LETRAS[i],
        columna: this.nombresColumnas[i],
        dato: datosFila[i],
        tipoError: 'columna'
      });
      this.erroresTotales++;
    }
  }
  //Si al terminar el ciclo de la fila la lista de errores es mayor a cero se agrega fila a array de errores
  if(listaErrores.length > 0){
    this.errores.push({
      numeroFila:numFila,
      datos: datosFila,
      listaErrores: listaErrores
    });
  }
  else{ //si no hay errores, se agrega a array de filas correctas
    this.filaCorrecta(datosFila,numColumnas);
  }
}

validacionAlfabetica(dato:any){
  return this.regexAlfabetico.test(dato);
}
validacionAlfanumerica(dato:any){
  return this.regexAlfanumerico.test(dato);
}
validacionNumerica(dato:any){
  return this.regexNumerico.test(dato);
}
validacionEmail(dato:any){
  return this.regexEmail.test(dato);
}

paridadBosskey(){
  let indiceOwnkey = this.clavesColumnas.indexOf('ownKey');
  let indiceBosskey = this.clavesColumnas.indexOf('bossKey');
  let erroresBosskey: any[] = [];
  this.data.forEach( (filaBoss,i) => {  //ciclo que recorre las filas del archivo
    if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
      if(filaBoss[0] != null){
        if(filaBoss[indiceBosskey] != 0){
          let encontrado = false;
          let BreakException2 = {};
          try {
            this.data.forEach( (filaOwn,j) => {  //ciclo que recorre las filas del archivo
              if(j >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
                if(filaOwn[0] != null){
                  if(filaBoss[indiceBosskey] === filaOwn[indiceOwnkey]){
                    encontrado = true;
                    throw BreakException2;
                  }
                }
              }
            });
          } catch (e) {
            if (e !== BreakException2) throw e;
          };
          if(!encontrado){

            let datosError = {
              numeroColumna: colabInter.LETRAS[indiceBosskey],
              columna: this.nombresColumnas[indiceBosskey],
              dato: filaBoss[indiceBosskey],
              tipoError: 'bosskeyNotFnd'
            };

            let indiceError = this.errores.findIndex(item => item.numeroFila == (i+1));
            if(indiceError != -1){
              this.errores[indiceError].listaErrores.push(datosError);
            }
            else{
              this.errores.push({
                numeroFila: (i+1),
                datos: filaBoss,
                listaErrores: [datosError]
              });
            }
          }
        }
      }
    }
  });
}

continuidadNiveles(){
  let nivGeo: any[] = [];
  let nivStr: any[] = [];

  this.clavesColumnas.forEach((columna,i) => {
    if(columna.includes("geo_")){
      nivGeo.push({
        indice: i,
        nombre: columna
      });
    }
    if(columna.includes("structure_")){
      nivStr.push({
        indice: i,
        nombre: columna
      });
    }
  });
  console.log("nivelesGeo:",nivGeo);
  console.log("nivelesStr:",nivStr);

  let BreakException = {};
  try {
    this.data.forEach( (fila,i) => {  //ciclo que recorre las filas del archivo
      if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
        if(fila[0] != null){
          let vacioPrevio = false;
          //recorre todos los niveles geograficos
          for (let itGeo = nivGeo[0].indice; itGeo < nivGeo[nivGeo.length-1].indice; itGeo++) {
            if(itGeo == nivGeo[0].indice){
              if(fila[itGeo] == undefined){
                vacioPrevio = true;
              }
            }
            else{
              if(fila[itGeo] == undefined){
                vacioPrevio = true;
              }
              else{
                if(vacioPrevio){
                  //genera error continuidad
                  this.errorNiveles(fila[i-1], (i+1), (itGeo-1), 'continuidad');
                  vacioPrevio = false;
                }
                // else{
                //   if(fila[itGeo-1] === fila[itGeo]){
                //     //genera error repetido contiguo
                //     this.errorNiveles(fila, (i+1), itGeo, 'nivelRepetido');
                //   }
                // }
              }
            }
          }
          //recorre todos los niveles estructurales
          vacioPrevio = false;
          for (let itStr = nivStr[0].indice; itStr < nivStr[nivStr.length-1].indice; itStr++) {
            if(itStr == nivStr[0].indice){
              if(fila[itStr] == undefined){
                vacioPrevio = true;
              }
            }
            else{
              if(fila[itStr] == undefined){
                vacioPrevio = true;
              }
              else{
                if(vacioPrevio){
                  //genera error continuidad
                  this.errorNiveles(fila[i-1], (i+1), (itStr-1), 'continuidad');
                  vacioPrevio = false;
                }
                // else{
                //   if(fila[itStr-1] === fila[itStr]){
                //     //genera error repetido contiguo
                //     this.errorNiveles(fila, (i+1), itStr, 'nivelRepetido');
                //   }
                // }
              }
            }
          }
        }
        else{
          throw BreakException;
        }
      }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  };

}

errorNiveles(datos:any, numeroFila:number, indiceColumna:number, tipoError:string){
  let datosError = {
    numeroColumna: colabInter.LETRAS[indiceColumna],
    columna: this.nombresColumnas[indiceColumna],
    dato: datos[indiceColumna],
    tipoError
  };

  let indiceError = this.errores.findIndex(item => item.numeroFila == numeroFila);
  if(indiceError != -1){
    this.errores[indiceError].listaErrores.push(datosError);
  }
  else{
    this.errores.push({
      numeroFila,
      datos,
      listaErrores: [datosError]
    });
  }
}

buscaRepetidos(datosFila:any, clave:string, numColumnas:number){
  let repetidoEncontrado = false;
  let BreakException = {};
  try {
    this.arregloColaboradores.forEach((colaborador) => {
      if(colaborador[clave] == datosFila){
        repetidoEncontrado = true;
        throw BreakException;
      }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  };
  return repetidoEncontrado;
}

filaCorrecta(datosFila:any,numColumnas:number){
  let colaborador = {} as colabInter.Colaborador;
  colaborador.productoId = ' ';
  colaborador.empresaId = localStorage.getItem('companyID');
  for(let i=0;i<numColumnas;i++){
    switch(this.clavesColumnas[i]){
      case 'ownKey': case 'bossKey': case 'surveyKey':
      if(typeof datosFila[i]==='string'){
        console.log('Entro a string');
        colaborador[this.clavesColumnas[i]] = datosFila[i].toString();
      }
      else{
        console.log('Entro a number');
        if(datosFila[i] > -1) colaborador[this.clavesColumnas[i]] = datosFila[i].toString();
      }
      break;
      case 'enterDate': colaborador[this.clavesColumnas[i]] = this.fechaCorrecta(datosFila[i]); break;
      case 'native':
        if(this.versionNueva){
          colaborador[this.clavesColumnas[i]] = datosFila[i];
          colaborador.lang = this.buscaClaveIdiomaNativo(datosFila[i]);
        }
        else{
          colaborador[this.clavesColumnas[i]] = datosFila[i];
          colaborador.lang = this.buscaClaveIdiomaNativo(datosFila[i]);
        }
      break;
      case 'answer':
        colaborador.sendingType = this.buscaClaveResponde(datosFila[i]);
        colaborador[this.clavesColumnas[i]] = datosFila[i];
      break;
      default: colaborador[this.clavesColumnas[i]] = datosFila[i];
    }
  }
  if(this.instituto == 'HK' || this.instituto == 'TK'){ //si es instituto hk o tr se agrega la surveykey random
    if(!colaborador.surveyKey){
      colaborador.surveyKey = this.clavesRandom();
    }
  }
  this.arregloColaboradores.push(colaborador);
}

buscaClaveResponde(responde:string){
  let clave: number;
  // let BreakException = {};
  // try {
  //   lang_perfiles.forEach(idioma => {
  //     // console.log("idioma:",idioma);
  //     let encontrado = false;
  //     if(idioma.data.RESPONDE){
  //       for(let k in idioma.data.RESPONDE){
  //         if(idioma.data.RESPONDE[k] == responde){
  //           encontrado = true;
  //           clave = parseInt(k);
  //           break;
  //         }
  //       }
  //       if(encontrado) throw BreakException;
  //     }
  //   });
  // } catch (e) {
  //   if (e !== BreakException) throw e;
  // };
  clave = parseInt(responde.substr(0,2));
  // if(clave < 10){
  //   clave = 1;
  // }
  return clave;
}

buscaClaveIdiomaNativo(nomIdioma:string){
  let clave: string;
  // let BreakException = {};
  // try {
  //   lang_idiomas.forEach(idioma => {
  //     let encontrado = false;
  //     for(let k in idioma.data.NOMBREIDIOMAS){
  //       if(idioma.data.NOMBREIDIOMAS[k] == nomIdioma){
  //         encontrado = true;
  //         clave = k;
  //         break;
  //       }
  //     }
  //     if(encontrado) throw BreakException;
  //   });
  // } catch (e) {
  //   if (e !== BreakException) throw e;
  // };
  clave = nomIdioma.substr(0,2);
  switch (clave) {
    case "z1": clave = "zh1"; break;
    case "z2": clave = "zh2"; break;
  }
  return clave;
}

fechaCorrecta(fechaActual:any){
  let fechaFinal: string;
  if(isNaN(fechaActual)){
    fechaFinal = fechaActual;
  }
  else{
    let fechaInicial = "30-12-1899";
    let fechaReal = this.moment(fechaInicial, "DD-MM-YYYY");
    fechaReal.add(fechaActual, 'days');
    fechaFinal = this.moment(fechaReal).format('DD/MM/YYYY');
  }
  return fechaFinal;
}

clavesRandom(){
  let clave: any;
  let claveOk = false;
  do {
    clave = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
    let indice = this.skhk.indexOf(clave);
    if(indice == -1){  //si no se encontro la clave
      this.skhk.push(clave);
      claveOk = true;
    }
  }
  while (!claveOk);
  return clave.toString();
}

guardarColaboradoresBD(){
  if(!this.pasoCompleto){
    if(this.arregloColaboradores.length > 0 && this.errores.length == 0 && this.erroresTotales == 0){
      console.log("columnas");
      console.log(this.nombresColumnasBD);
      console.log("colaboradores");
      console.log(this.arregloColaboradores);
      Swal.fire({
        title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_1') + this.arregloColaboradores.length + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_2'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI'),
        cancelButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO')
      }).then((result) => {
        if (result.value) {
          this.guardandoBD = true;
          let inicio = new Date();
          let fin: any;
          this.colaboradoresService.guardaColaboradoresEmpresa(this.nombresColumnasBD, this.arregloColaboradores)
          .subscribe( (respuesta: colabInter.respuestaGuardaBD) => {
            if(respuesta.message == '230'){
              fin = new Date();
              let fx = (fin.getTime() - inicio.getTime()) / 1000;
              console.log("tiempo de guardado de bd en backend: "+fx+" segs");
              this.colaboradoresService.getColaboradoresEmpresaFoc().subscribe( (getFast: any) => {

                if(getFast.success == true){
                  this.deleteAttachment();
                  this.guardandoBD = false;
                  this.colabsEnBD = getFast.numeroColaboradores;
                  this.fechaCarga = getFast.fecha;
                  this.irProducto=true;
                  // this.getHistrialCreacionColaboradores();

                  this.stored = true;
                  this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDADO'), 1);
                }
                else{
                  this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR'), 3);
                }
              });
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR'), 3);
            }
          });
        }
      });
    }
  }
  else{
    //mensaje swal
  }
}


openDialog(): void {
  console.log('la llamo');

const dialogRef = this.dialog.open(DialogModalFocus, {
width: '22em',
height: '22em',
panelClass: 'my-dialog',
});

dialogRef.afterClosed().subscribe(result => {
console.log('The dialog was closed');
});
}

ModalArchivo(){
  let botonModalArchivo = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.ARCHIVOCOMFIRM';
  this.translateSrv.get(botonModalArchivo).subscribe((res: string) => { botonModalArchivo = res; });
  let rspEnterado = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });
  Swal.fire({
    title: botonModalArchivo,
    icon: 'warning',
    showCancelButton: false,

    confirmButtonText: rspEnterado,

  });
}

modalInformativo(){
  let texto = 'dsjfasjfd';
  let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
  Swal.fire({
    icon: 'info',
    title: texto,
    input: "checkbox",
    // inputPlaceholder: botonModal,
    // inputValidator: (result)=>{
    //   //alert(result);
    //   return new Promise((resolve)=>{
    //     if (result){
    //       this.updateStatusModal();
    //     }
    //     resolve();
    //   });
    // },

    confirmButtonText: rspSi,
    allowOutsideClick: false
  })
}

openDialogCreaEncues(): void {

  let dataModal: any;
  const dialogRef = this.dialog.open(ModalAgregarEncComponent, {
    width: '40%',
    height: '50%',
    disableClose: true,
    // data: {
    //   fecha:fecha,
    //   idProducto:idproducto,
    //   tipoProducto:tipoproducto,
    //   plantilla:plantilla,
    //   idEmpresa:this.idEmpresa,
    //   nombreEmpresa:this.nombreEmpresa,
    //   codigoDeProyecto:this.codigoDeProyecto,
    //   productoId:producId,
    //   instituto:localStorage.getItem('instituto_correos'),
    // }
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('result',result);

    if (result==1) {
      console.log('entro este visne x1 ');
      this.getProductsByCompany();
    }else{
      console.log('entro este visne x2 ');

    }


  });
}


analizarExcel(evt: any) {
  console.log('evt',evt);

  this.versionNueva = false;
  this.cargandoBD = true;
  let fec1 = new Date();
  /* wire up file reader */
  const target: DataTransfer = <DataTransfer>(evt.target);
  if (target.files.length !== 1) throw new Error('Cannot use multiple files');

  if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      let datos = {
        productoId: " ",
        empresaId: localStorage.getItem('companyID'),
        instituto: this.instituto,
        versionesActualExcel: this.versionesActualExcel,
        datos: e.target.result,
        seccEspHabilitadas: this.seccEspHabilitadas,
        seccionesEspeciales: this.seccionesEspeciales,
      };
      console.log('datos:::::::::::::::::::::::::',datos);

      this.colaboradoresService.enviarBD_analisis(datos).subscribe((respuesta:any) => {
        console.log("enviarBD_analisis:",respuesta);
        if(respuesta.success){
          this.cargandoBD = false;
          this.nombresColumnasBD = respuesta.nombresColumnasBD;
          this.arregloColaboradores = respuesta.arregloColaboradores;
          if(respuesta.erroresTotales > 0){
            this.modalErrores(respuesta);
          }
          let fec2 = new Date();
          let fx = (fec2.getTime() - fec1.getTime()) / 1000;

          console.log("registros cargados: "+this.arregloColaboradores.length);
          console.log("tiempo de carga de bd en front: "+fx+" segs");
          // console.log("valor final de barporcen: "+this.barPorcen);

          let arcs = evt.target.files
          for (let index = 0; index < arcs.length; index++) {
            const element = arcs[index];
            // console.log(element);
            this.files.push(element.name)
          }
          console.log("files de colabroadores::",this.files);

          // this.deleteAttachment();
        } else{
          this.mensajeSwal(this.translateSrv.instant(respuesta.mensajeError), 3); //mensaje de extensión incorrecta
          this.cargandoBD = false;
          this.deleteAttachment();
        }
      }, error  => {
        console.log("error");
        this.cargandoBD = false;
        this.deleteAttachment();
      });
    };
    reader.readAsBinaryString(target.files[0]);
  }
  else{
    this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
    this.cargandoBD = false;
    console.log("trono aqui :V");
  }
}

getVersionExcel(){
  this.colaboradoresService.getVersionExcel().subscribe((respuesta:any) => {
    console.log("getVersionExcel:",respuesta);
    if(respuesta.success){
      this.versionesActualExcel = respuesta.version.versiones;
    }
  });
}

modalErrores(datos:any){
  const dialogRef = this.dialog.open(ModalErroresComponent, {
    width: '50%',
    disableClose: true,
    data: {
      erroresTotales: datos.erroresTotales,
      erroresCategorizados: datos.erroresCategorizados
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    this.deleteAttachment();
  });
}

}





@Component({
  selector: 'DialogModalFocus',
  templateUrl: 'dialog-overview-example-dialog.html',
  styleUrls: ['matDialog.component.scss'],
})
export class DialogModalFocus {

  constructor(
    public dialogRef: MatDialogRef<DialogModalFocus>,
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
